import script from "./quote-management.vue?vue&type=script&setup=true&lang=js"
export * from "./quote-management.vue?vue&type=script&setup=true&lang=js"

import "./quote-management.vue?vue&type=style&index=0&id=091b42d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-091b42d0"]])

export default __exports__